import { FC, useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import Breadcrumb from '../../Components/Breadcrumb';
import InventaireService from './service'; 

//Moment react
import Moment from 'react-moment';

import {
    Link, useNavigate
} from "react-router-dom";
import { useTranslation } from 'react-i18next';

const InventaireList: FC = () => {  

    let idToModInit: any = null;
    const [ inventaires, setInventaires ] = useState( [] );
    const [ idToMod, setIdToMod ] = useState(idToModInit);
    const [ loading, setLoading ] = useState(false);
    const inventaireService = new InventaireService();

    const navigate = useNavigate();
    const { t } = useTranslation();

    let editAgent = (id: Number): void => {
        setIdToMod(id);
        setLoading(true);
        navigate('/agent/edit/'+id.toString());
        setLoading(false);
    }

    const getInventaires = () => {
        setLoading(true);
        inventaireService.getInventaires().then(async function (response: any) {
            console.log(response);
            // if ( response.data.length ) {
            //     setInventaires(response.data);
            // } 
            setLoading(false); 
        })
          .catch(function (error: any) {
            console.log(error);
            setLoading(false); 
        });
    }

    useEffect(function() { 
        getInventaires();
    }, []);

    const columns = [
        {
            name: '#',
            selector: (row: any) => row.id,
        },
        {
            name: `${ t('Boutique') }` ,
            selector: (row: any) => row.boutique.libBoutique,
        },
        {
            name: `${ t('Agent') }`,
            selector: (row: any) => row.agent.prenomAgent + ' '+  row.agent.nomAgent,
        },
        {
            name: `${ t('Date') }`,
            selector: (row: any) => <Moment format="YYYY/MM/DD hh:mm:ss">
                                        {row.dateInventaire}
                                    </Moment>
        },
        {
            name: "Options", 
            selector: (row: any) => (
                <>
                    {/* <button type="button" onClick={event => {
                            navigate('/client/edit/'+row.id.toString());
                        }}
                            className="btn waves-effect waves-light btn-success">
                                <span className="" style={{ fontSize: "1em" }} >
                                    <i className="icon-pencil"></i></span>
                    </button>
                    <button type="button" onClick={event => {  }}
                        className="btn waves-effect waves-light btn-danger"> 
                                <span className="" style={{ fontSize: "1em" }} >
                                <i className="icon-trash"></i></span>
                            
                    </button>  */}
                </>
            )
        }
    ];
    

    return (
            <> 
                <Breadcrumb />
 
                <div className="container-fluid">
    
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="btn-list">
                                    <button type="button" onClick={ event => getInventaires() }
                                        className="btn waves-effect waves-light btn-danger">
                                            { t('Actualiser') }
                                        </button>
                                        <Link type="button" to="/inventaire/create/manuel"
                                            className="btn waves-effect waves-light btn-outline-primary">
                                                { t('Inventaire manuel') } 
                                        </Link>
                                        <Link type="button" to="/inventaire/create/automatique"
                                            className="btn waves-effect waves-light btn-outline-success">
                                                { t('Inventaire automatique') }    
                                        </Link>
                                    </div>
                                    
                                    <br />
                                    <br /> 

                                        <div className="table-responsive">
                                            <DataTable
                                                responsive={true}
                                                className="table table-striped table-bordered"
                                                columns={columns}
                                                data={ inventaires }
                                                progressPending={loading}
                                                pagination
                                            />
                                        </div>

                                    </div>
                                </div> 
                        </div> 
                    </div>

                </div>   
            </>                   

    );
}

export default InventaireList